import { LocalUser } from '@/shared/lib/db'
import { create } from 'zustand'

interface AuthState {
    user: LocalUser | null
    loading: boolean
    setUser: (user: LocalUser | null) => void
    setLoading: (loading: boolean) => void
}

export const useAuthStore = create<AuthState>((set) => ({
    user: null,
    loading: true,
    setUser: (user) => set({ user }),
    setLoading: (loading) => set({ loading }),
}))

// Export a hook that mimics the old API for easier refactoring
export const useAuth = () => {
    const { user, loading } = useAuthStore()
    return { user, loading }
}
